// @ts-nocheck
import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";

export const ErrorContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing.small,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.spacing.medium,
    marginTop: theme.spacing.small,
    marginBottom: theme.spacing.small,
    minHeight: 200,
}));

export const WarningImage = styled(Image)(({ theme }) => ({
    width: 52,
    height: 52,
    marginBottom: theme.spacing.small,
}));

export const ErrorMessage = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Med_Emphasis,
    textAlign: "center",
}));

export const StyledRetryButton = styled(Button)(({ theme }) => ({
    marginTop: theme.spacing.small,
}));
